import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import ErrorMessage from '../ErrorMessage/ErrorMessage';

export default function SelectRemote(props) {
  const [open, setOpen] = React.useState(false);
  const [optionsMap, setMap] = React.useState({});
  const { errors } = props;
  const hasErrors = errors && errors.length > 0;

  const onCompleted = (d) => {
    const optionsMap = d[props.dataKey].reduce((acc, curr) => {
      acc[curr[props.valueKey]] = curr;
      return acc;
    }, {});
    setMap(optionsMap);
  };

  if (props.preInit) {
    useQuery(props.query, {
      fetchPolicy: 'network-only',
      variables: props.variables,
      onCompleted,
    });
  }

  const [getQuery, { loading, data }] = useLazyQuery(props.query, {
    fetchPolicy: 'network-only',
    variables: props.variables,
    onCompleted,
  });

  const handleOpen = () => {
    setOpen(true);
    getQuery();
  };

  const handleOnchange = (e, v) => {
    if (props.onChange) {
      if (props.valueAsObject) {
        props.onChange({ target: { name: props.name, value: v || null } });
      } else {
        props.onChange({
          target: { name: props.name, value: v ? v[props.valueKey] : '' },
        });
      }
    }
  };

  return (
    <Autocomplete
      id={props.id}
      name={props.name}
      open={open}
      onOpen={handleOpen}
      onClose={() => {
        setOpen(false);
      }}
      getOptionSelected={(option, value) =>
        option[props.valueKey] === value[props.valueKey]
      }
      getOptionLabel={
        props.getOptionLabel
          ? props.getOptionLabel
          : (option) => (option[props.labelKey] ? option[props.labelKey] : '')
      }
      options={data ? data[props.dataKey] : []}
      loading={loading}
      value={optionsMap[props.value] ? optionsMap[props.value] : ''}
      onChange={handleOnchange}
      disabled={props.disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          required={props.required}
          margin={props.margin}
          value={props.value}
          label={props.label}
          variant='outlined'
          error={hasErrors}
          helperText={<ErrorMessage errors={errors} />}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color='inherit' size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}

SelectRemote.defaultProps = {
  valueKey: 'id',
  labelKey: 'label',
};
